export default "__VITE_ASSET__Ms9SRFtw__"